import { configureApi } from "@pracownik/sdk-web";

const LOCAL_HOSTS = new Set(["localhost", "mac-mini"]);

configureApi(() => {
  if (typeof window === "undefined") return "";
  if (LOCAL_HOSTS.has(window.location.hostname)) return ""; // proxied via Vite
  return "https://api.pracownik.ai";
});
